const ColumnFilterMenuTestIdsScope = {
  COLUMN_FILTER: 'column-filter',
};

export const ColumnFilterMenuTestIds = {
  TRIGGER: `${ColumnFilterMenuTestIdsScope.COLUMN_FILTER}.trigger`,
  MODE_SELECT: `${ColumnFilterMenuTestIdsScope.COLUMN_FILTER}.mode-select`,
  VALUE_INPUT: `${ColumnFilterMenuTestIdsScope.COLUMN_FILTER}.value-input`,
  CLEAR_BUTTON: `${ColumnFilterMenuTestIdsScope.COLUMN_FILTER}.clear-button`,
  APPLY_BUTTON: `${ColumnFilterMenuTestIdsScope.COLUMN_FILTER}.apply-button`,
  getModeOptionId: mode =>
    `${ColumnFilterMenuTestIdsScope.COLUMN_FILTER}.mode-option-${String(mode).toLowerCase()}`,
};
